import { render, staticRenderFns } from "./MotivoAfastamentos.vue?vue&type=template&id=3d38541f&scoped=true&"
import script from "./MotivoAfastamentos.vue?vue&type=script&lang=js&"
export * from "./MotivoAfastamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38541f",
  null
  
)

export default component.exports